var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ContentBaseService } from '../base/contentbase.service';
import { ApiService } from '../../service/api.service';
var TreeService = /** @class */ (function (_super) {
    __extends(TreeService, _super);
    function TreeService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    TreeService.prototype.init = function () {
    };
    TreeService.prototype.open = function (params) {
    };
    TreeService.prototype.unsubscribe = function () {
    };
    TreeService.prototype.getNode = function (id) {
        return null;
    };
    TreeService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    TreeService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return TreeService;
}(ContentBaseService));
export { TreeService };
var NodeState = /** @class */ (function () {
    function NodeState() {
        this.opened = false;
        this.disabled = false;
        this.selected = false;
        this.checked = false;
    }
    return NodeState;
}());
export { NodeState };
var TreeNode = /** @class */ (function () {
    function TreeNode(rec) {
        this.state = new NodeState();
        this.children = [];
        this.li_attr = {};
        this.a_attr = {};
        this.ref = rec;
        this.data = rec;
        if (rec != null) {
            if (rec['label'] != null) {
                this.text = rec.label;
            }
        }
    }
    return TreeNode;
}());
export { TreeNode };
//# sourceMappingURL=tree.service.js.map